// Container injecting contexts into the dumb TaskItemBase.
// @ts-check
import { memo } from 'react';
import TaskItemBase from './TaskItemBase';

/**
 * TaskItem — Smart wrapper that now primarily delegates to TaskItemBase.
 * TaskItemBase consumes most of its own data via hooks.
 * @param {{ task: Task } & Record<string, any>} props
 */
const TaskItem = (props) => {
  return <TaskItemBase {...props} />;
};

export default memo(TaskItem);
